import React from 'react';
import { Link } from 'react-router-dom';

export const Logo = ({ size = 'sm' }) => (
  <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="logo-link">
    <div className={`${size === 'lg' ? 'w-10 h-10' : 'w-9 h-9'} rounded-xl bg-[#0F8B5C] flex items-center justify-center text-white font-black text-lg shadow-sm`}>K</div>
    <span className={`font-black tracking-tight ${size === 'lg' ? 'text-2xl text-white' : 'text-xl text-[#1A1A1A]'}`}>Kushe</span>
  </Link>
);
